import { useContext } from 'react';
import { FullscreenContext } from 'contexts/Fullscreen';

const useFullscreen = () => useContext(FullscreenContext);
export default useFullscreen;
